import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./loading.css"
import { countryCodes } from '../Data/data';
import axios from "axios"







const PopupForm = ({ setOpen }) => {



  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    countryCode:'',    
      message:'lead',
  });

  const [loading, setLoading] = useState(false);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { name, phone, email } = formData;
    
    if (!name?.trim() || !phone?.trim() || !email?.trim()) {
      return toast.error('Please enter your details', {
        position: 'top-right',
      });
    } 
    

    try {
      setLoading(true);

     await axios.post('https://admin.socioloom.com/test.php',formData,{
        headers: {
          "Content-Type": "application/json",
        }});

    } catch (error) {
      console.log(error);
    }

    setLoading(false);
   
    setOpen(false);
    
    setFormData({
      name: '',
      phone: '',
      email: '',
      countryCode:'',
      message:'lead',
    });
    
  };
  

  return (
    <>
  <div>
<ToastContainer />
{loading ? (<div className='fixed h-[100%] w-[100%] !z-50 bg-[#000000dd] flex items-center justify-center'>
 <div class="custom-loader"></div>
 </div>)  :
 <div className="fixed z-50 inset-0 flex items-center justify-center bg-black bg-opacity-50 mt-10">
      <div className="bg-white p-8 rounded-md shadow-md">
        <div className="flex justify-end">
          <button className="text-gray-500 hover:text-gray-700" onClick={()=>setOpen(false)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="h-6 w-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="name" className="block text-sm font-medium text-gray-700">
              Name
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter Your Name"
              className="mt-1 p-2 border rounded-md w-full"
            />
          </div>
         
          <div className="mb-4">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
              Email
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="john@example.com"
              className="mt-1 p-2 border rounded-md w-full"
            />
          </div>
          <div className="mb-4">
            <label htmlFor="phoneNumber" className="block text-sm font-medium text-gray-700">
              Phone Number
            </label>
            <div className="flex">
            <select name="countryCode" value={formData?.countryCode}  onChange={handleChange} className="p-2 border rounded-md w-2/5 text-gray-400 max-sm:w-3/5 max-sm:text-[12px] max-md:text-sm text-md">
            {
              countryCodes.sort((a,b)=> a.label > b.label ? 1 : -1).map((item, index)=>{
                return(
                  <option value={`${item?.value} ${item?.label}`} key={index} >{item?.label}</option>
                )
              })
            }
             
            </select>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Phone Number"
                className="p-2 border rounded-md w-3/4"
              />
            </div>
          </div>
         
          <button
            type="submit"
            className=" w-full bg-[#510069] text-white py-2 px-4 rounded-md hover:bg-blue-700"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
   }
    </div>
  </>
  );
};

export default PopupForm;